import { Component, OnInit, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { UserHasClaim, selectUserSession } from 'src/app/main/shared/services/store/user/selector';
import { IUserSession } from 'src/app/core/dto';
import { ClickOutsideDirective } from 'src/@fury/shared/click-outside/click-outside.directive';
import { AuthService } from 'src/app/main/shared/services/auth.service';
import { PreferencesPickerComponent } from 'src/app/main/shared/components/preferences-picker/preferences-picker.component';
import { AppThemeService, THEME_PICKER_CLAIM } from 'src/app/main/shared/services/app-theme.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'fury-toolbar-user',
  templateUrl: './toolbar-user.component.html',
  styleUrls: ['./toolbar-user.component.scss'],
  imports: [
    RouterModule,
    FlexLayoutModule,
    MatButtonModule,
    MatIconModule,
    ClickOutsideDirective,
    PreferencesPickerComponent,
    TranslateModule,
  ],
})
export class ToolbarUserComponent implements OnInit {
  isOpen: boolean;
  user: IUserSession;
  readonly canPickTheme: Signal<boolean>;

  constructor(
    private store: Store,
    private authService: AuthService,
    private appTheme: AppThemeService
  ) {
    this.canPickTheme = this.store.selectSignal(UserHasClaim(THEME_PICKER_CLAIM));
    this.store.select(selectUserSession).subscribe((user) => {
      if (user !== null) {
        this.user = { ...user };
      } else {
        this.user = { userName: '' } as IUserSession;
      }
    });
  }

  ngOnInit() {}

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  onClickOutside(event?: MouseEvent) {
    // The language/units selects render their options in a CDK overlay attached
    // to the body, so picking an option reads as a click outside this dropdown.
    // Ignore those, or the dropdown closes and leaves the option list floating.
    const target = event?.target as HTMLElement | null;
    if (target?.closest('.cdk-overlay-container')) {
      return;
    }
    this.isOpen = false;
  }

  useSteelTheme() {
    this.isOpen = false;
    this.appTheme.setTheme('steel');
  }

  logout() {
    this.isOpen = false;
    this.authService.logout();
  }
}
